import React from 'react';

interface AssessmentProgressProps {
  currentStep: number;
  totalSteps: number;
  completedSections: number;
}

const AssessmentProgress = ({ currentStep, totalSteps, completedSections }: AssessmentProgressProps) => {
  const progressPercentage = (completedSections / totalSteps) * 100;

  return (
    <div className="bg-card rounded-lg p-6 shadow-subtle border border-border">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-display font-semibold text-secondary">Assessment Progress</h3>
        <span className="text-sm font-medium text-muted-foreground">
          {completedSections} of {totalSteps} sections completed
        </span>
      </div>
      
      <div className="relative w-full h-3 bg-muted rounded-full overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary to-accent transition-all duration-500 ease-out"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      
      <div className="mt-4 flex items-center justify-between text-sm">
        <span className="text-muted-foreground">Step {currentStep} of {totalSteps}</span>
        <span className="font-medium text-accent">{Math.round(progressPercentage)}% Complete</span>
      </div>
    </div>
  );
};

export default AssessmentProgress;